import { render, staticRenderFns } from "./NewsMultiple.vue?vue&type=template&id=0bc7470d&scoped=true&"
import script from "./NewsMultiple.vue?vue&type=script&lang=ts&"
export * from "./NewsMultiple.vue?vue&type=script&lang=ts&"
import style0 from "./NewsMultiple.vue?vue&type=style&index=0&id=0bc7470d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc7470d",
  null
  
)

export default component.exports